import { Actions, ActionTypes } from '../actions/unit';
import { Unit } from '../models/unit';
import { UnitEmployment } from '../models/unitEmployment';

export interface State {
  units: any[];
  selectedUnitId: number;
  selectedUnit: Unit;
  unitUsers: Array<any>;
  errors: any[];
  selectedUnitEmployment: UnitEmployment;
}

export const initialState: State = {
  units: null,
  selectedUnitId: null,
  selectedUnit: null,
  unitUsers: [],
  errors: [],
  selectedUnitEmployment: null,
};

export function unitReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.LoadUnitsSuccess:
      const newState = action.payload.focusParent
        ? {
            ...state,
            units: action.payload.units,
            selectedUnit: action.payload.units[0],
          }
        : { ...state, units: action.payload.units };
      return newState;

    case ActionTypes.UpdateUnitSuccess:
      return { ...state, selectedUnit: action.payload.unit };

    case ActionTypes.LoadUnitSuccess:
      return {
        ...state,
        selectedUnit: action.payload.unit,
        selectedUnitId: action.payload.unit.id,
      };

    case ActionTypes.LoadUnitUsersSuccess:
      return { ...state, unitUsers: action.payload.users };

    case ActionTypes.DeleteUnitEmploymentSuccess:
      const newUnitUsers = state.unitUsers.filter(
        user => user.id !== action.payload.id
      );
      return { ...state, unitUsers: newUnitUsers };

    // case ActionTypes.UpdateUnit:
    //     return {...state, selectedUnit: action.payload.unit, selectedUnitId: action.payload.unit.id};

    case ActionTypes.LoadUnitsFail:
      return { ...state, errors: action.payload.errors };

    case ActionTypes.SelectUnitEmployment:
      return {
        ...state,
        selectedUnitEmployment: action.payload.unitEmployment,
      };

    case ActionTypes.UpdateUnitEmploymentSuccess:
      const newEployments = state.unitUsers.map(user =>
        user.id === action.payload.unitEmployment.id
          ? action.payload.unitEmployment
          : user
      );
      return {
        ...state,
        unitUsers: newEployments,
        selectedUnitEmployment: action.payload.unitEmployment,
      };

    default:
      return state;
  }
}

export const getUnits = (state: State) => state.units;
export const getUnitsErrors = (state: State) => state.errors;
export const getSelectedUnit = (state: State) => state.selectedUnit;
export const getSelectedUnitId = (state: State) => state.selectedUnitId;
export const getUnitUsers = (state: State) => state.unitUsers;
export const getSelectedUnitEmployment = (state: State) =>
  state.selectedUnitEmployment;
